/* eslint-disable */

import React, {Component} from 'react'
import {message} from 'antd'
import http from '../../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import HeaderGrid from '../../Pagination/HeaderGrid'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import '../../../style/payment-base.css'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'

class Banks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSize: 20,
      pageNumber: 1,
      Banks: [],
      CountAll: 0,
      printInfo: [],
      modalDelete: false,
      deleteId: 0,
      modalEdit: false,
      editId: 0,
      editName: '',
      error: ''
    }
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  componentDidMount() {
    this.getAllBanks()
  }

  getAllBanks = () => {
    http.get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_LIST_BANK}`, {}).then((res) => {
      if (res.data.error === null) {
        $('.showBaseTable').fadeIn()

        this.setState({
          Banks: res.data.object
          // CountAll: res.data.object.countAll
        })
      } else {
        $('.showBaseTable').fadeOut()
      }
    })
  }
  edit = (numid, name) => {
    this.setState({
      modalEdit: !this.state.modalEdit,
      editId: numid,
      editName: name
    })
  }
  editOk = () => {
    let bank = this.state.editName
    let id = this.state.editId
    let newBank = document.getElementById('bank').value

    let bankError = false
    let newBankError = false
    let formError = false

    if (newBank == '') {
      formError = true
      newBankError = true
    } else {
      if (!newBankError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: newBank,
        id: id
      }

      http
        .put(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_UPDATE_BANK}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('نام بانک تغییر یافت')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
            this.getAllBanks()
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }
  editCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit,
      editId: 0,
      editName: ''
    })
  }

  delete = (numId) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      deleteId: numId
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }
  deleteOk = () => {
    let bankId = this.state.deleteId

    http
      .delete(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_DELETE_BANK}/${bankId}`, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          message.success('بانک با موفقیت حذف شد')

          this.setState({
            modalDelete: !this.state.modalDelete,
            deleteId: 0
          })
          this.getAllBanks()
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete,
            deleteId: 0
          })
        }
      })
      .catch((error) => {
        this.setState({
          modalDelete: !this.state.modalDelete,
          deleteId: 0
        })

        alert(JSON.stringify(error))
      })
  }

  render() {
    let {Banks, pageSize, pageNumber, editId, editName} = this.state

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>پرداخت</li>
            <li>بانک ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <button className="add-butt">
                <Link style={{color: 'white'}} to={'/addbank'}>
                  {' '}
                  افزودن{' '}
                </Link>
              </button>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>بانک</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.Banks.map((bank, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{bank.name}</td>
                      <td>
                        <button onClick={() => this.edit(bank.id, bank.name)}>
                          <img src={require('../../../image/editDriver.svg')} alt={'edit'} />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(bank.id)}>
                          <img src={require('../../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.toggleCancel} size="sm">
            <ModalHeader toggle={this.toggleCancel}>حذف بانک</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف بانک مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف بانک
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalEdit} toggle={this.toggleCancel} size="sm">
            <ModalHeader toggle={this.toggleCancel}>ویرایش بانک</ModalHeader>
            <ModalBody>
              <label>
                نام بانک <span className="requireFiled"> * </span>
              </label>
              <input type="text" id="bank" className="form-control" defaultValue={editName} />
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.editOk}>
                ویرایش نام بانک
              </button>
              <button className="cancelBtnModal" onClick={this.editCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Banks
